<script lang="ts">
  import {
    clearSharedAccountAccess,
    ensureSharedAccountAccess,
    fetchUser,
    post,
    prepareSharedAccountContextFromAuthResponse,
    reconcileSharedAccountContextWithUser,
    serverlessRoutes,
    isClient,
    storage,
    initiateUser,
    errorTracker,
  } from "lib";
  import { onMount } from "svelte";
  import { replace } from "svelte-spa-router";

  export let params: { jwt?: string } = {};

  const goToExpired = (): void => {
    replace("/login?reason=expired");
  };

  onMount(async () => {
    const handoff = params.jwt ?? "";

    if (!handoff) {
      goToExpired();
      return;
    }

    try {
      const url = `${serverlessRoutes.AUTH}/autologin-exchange`;
      const res = await post(url, { handoff });

      if (!res?.accessToken) {
        goToExpired();
        return;
      }

      await clearSharedAccountAccess();
      await storage.set("authJwt", res.accessToken);

      await prepareSharedAccountContextFromAuthResponse(res);

      const hasSharedAccountAccess = await ensureSharedAccountAccess();
      if (!hasSharedAccountAccess) {
        goToExpired();
        return;
      }

      const fetchedUser = await fetchUser();
      if (!fetchedUser) {
        goToExpired();
        return;
      }

      await reconcileSharedAccountContextWithUser(fetchedUser);
      await initiateUser();

      if (!isClient(fetchedUser)) {
        replace("/clients/list");
      } else {
        replace("/training/program");
      }
    } catch (err) {
      errorTracker.captureError(err as Error | string, "error", {
        context: "autologin_handoff",
        action: "exchange_handoff_jwt",
      });
      goToExpired();
    }
  });
</script>
